import { useState, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';

function StatusRow({ label, check }) {
  const bg    = check.ok ? '#DCFCE7' : '#FFE4E6';
  const color = check.ok ? '#15803D' : '#BE123C';
  const icon  = check.ok ? '✓' : '✗';
  return (
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center',
                  padding:'0.75rem 1rem', borderBottom:'1px solid #F1F5F9' }}>
      <div style={{ fontWeight:600, color:'#1B2A4A', fontSize:'0.9rem' }}>{label}</div>
      <div style={{ display:'flex', alignItems:'center', gap:'0.5rem' }}>
        <span style={{ fontSize:'0.85rem', color:'#64748B' }}>{check.detail || check.label}</span>
        <span style={{ background:bg, color, borderRadius:4,
                        padding:'0.15rem 0.5rem', fontSize:'0.8rem', fontWeight:700 }}>
          {icon} {check.label}
        </span>
      </div>
    </div>
  );
}

function Status() {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const fetchStatus = () => {
    setLoading(true);
    fetch('/api/status')
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  };

  useEffect(() => { fetchStatus(); }, []);

  if (loading) return <div className='page'><LoadingSpinner message='Checking system status...' /></div>;

  return (
    <div className='page'>
      <div style={{ display:'flex', justifyContent:'space-between',
                    alignItems:'center', marginBottom:'1.5rem' }}>
        <h2>System Status</h2>
        <button onClick={fetchStatus}
          style={{ padding:'0.4rem 1rem', background:'#0E7C7B', color:'#fff',
                   border:'none', borderRadius:4, cursor:'pointer' }}>
          Refresh
        </button>
      </div>

      {/* Overall status banner */}
      {data && (
        <div style={{
          background: data.allOk ? '#DCFCE7' : '#FFE4E6',
          border: `2px solid ${data.allOk ? '#15803D' : '#BE123C'}`,
          borderRadius: 8, padding: '1rem 1.5rem',
          marginBottom: '1.5rem', textAlign:'center',
        }}>
          <div style={{ fontSize:'1.25rem', fontWeight:800,
                        color: data.allOk ? '#15803D' : '#BE123C' }}>
            {data.allOk ? '✓ All Systems Operational' : '⚠ Issues Detected'}
          </div>
          <div style={{ fontSize:'0.8rem', color:'#64748B', marginTop:'0.25rem' }}>
            Server uptime: {data.uptime}  ·  Checked: {new Date(data.timestamp).toLocaleTimeString()}
          </div>
        </div>
      )}

      {/* Status checks */}
      {data?.checks && (
        <div style={{ background:'#fff', borderRadius:8,
                      boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
          {[
            ['QuickBooks Token',    data.checks.qbToken],
            ['QuickBooks Company',  data.checks.qbCompany],
            ['QB Budget (Live)',    data.checks.budgetFile],
            ['SQLite Database',     data.checks.database],
            ['Anthropic API Key',   data.checks.anthropicKey],
            ['Email Configuration', data.checks.email],
            ['Alert Threshold',     data.checks.alertThreshold],
          ].map(([label, check]) => check ? (
            <StatusRow key={label} label={label} check={check} />
          ) : null)}
        </div>
      )}

      {error && (
        <div style={{ color:'#BE123C', padding:'1rem' }}>Error: {error}</div>
      )}
    </div>
  );
}

export default Status;
